module.exports = process.env.NODE_ENV === 'production'
  ? require('./messengerExtensions.development.js')
  : require('./messengerExtensions.development.js')



// WEBPACK FOOTER //
// ./src/lib/messengerExtensions.js